export default function AppleStoreButton() {
  return (
    <a
      href="https://apps.apple.com/gb/app/sono-su-fishing-for-treasure/id6450835384"
      target="_blank"
      rel="noreferrer"
    >
      <div className="applestore-logo"></div>
    </a>
  );
}
